module.exports = __webpack_public_path__ + "static/media/3ee50f6056c65d6fb1981c899ebd5cd95a6eba2d-24x24.c6d0ef05.png";